import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import { searchModule } from "../../utils/Utils";
import { setAlert } from "../../../actions/alertActions";

import "../../../styles/components/evs/modals/AssignDriver.scss";
import CheckCard from "../../utils/components/CheckCard";
import DoubleRadioCard from "../../utils/components/DoubleRadioCard";

class AssignDriver extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      search: "",
      tabIndex: 0,
      isScrolled: false,

      groups: [],
      drivers: [],
    };

    this.fetchGroupDrivers = this.fetchGroupDrivers.bind(this);
    this.fetchDrivers = this.fetchDrivers.bind(this);
    this.handleFetchedGroups = this.handleFetchedGroups.bind(this);
    this.handleFetchedDrivers = this.handleFetchedDrivers.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleOnCheck = this.handleOnCheck.bind(this);
    this.handleOnCardSubmit = this.handleOnCardSubmit.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleOnPaymentChange = this.handleOnPaymentChange.bind(this);
    this.handleOnBillingChange = this.handleOnBillingChange.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.hasOwnProperty("selectedEV") &&
      this.props.selectedEV !== null
    ) {
      if (
        prevProps.selectedEV === null ||
        prevProps.selectedEV.evId !== this.props.selectedEV.evId
      )
        this.fetchAll();
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  fetchAll() {
    Promise.all([this.fetchGroupDrivers(), this.fetchDrivers()]).then((res) => {
      const groups = res[0];
      const drivers = res[1];
      this.safeSetState({
        groups: this.handleFetchedGroups(groups),
        drivers: this.handleFetchedDrivers(drivers),
      });
    });
  }

  fetchGroupDrivers() {
    return axios
      .get("/api/private/groupDrivers", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  fetchDrivers() {
    return axios
      .get("/api/private/drivers", {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .catch((err) =>
        this.props.setAlert(err?.response?.data?.message, "danger")
      );
  }

  handleFetchedGroups(groups) {
    return groups?.status === 200
      ? groups.data
          .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
          .map((g) => {
            const ev = this.props.selectedEV;
            const idx =
              ev && ev.listOfGroupDrivers
                ? ev.listOfGroupDrivers.findIndex((i) => i.groupId === g._id)
                : -1;
            return Object.assign(g, {
              checked: idx !== -1,
              period:
                idx !== -1
                  ? ev.listOfGroupDrivers[idx].period
                  : { periodType: "always" },
              paymenteBy:
                idx !== -1 ? ev.listOfGroupDrivers[idx].paymenteBy : "driver",
              billingBy:
                idx !== -1 ? ev.listOfGroupDrivers[idx].billingBy : "driver",
            });
          })
      : [];
  }

  handleFetchedDrivers(drivers) {
    return drivers?.status === 200
      ? drivers.data.poolOfDrivers
          .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
          .map((d) => {
            const ev = this.props.selectedEV;
            const idx =
              ev && ev.listOfDrivers
                ? ev.listOfDrivers.findIndex((i) => i.userId === d.driverId)
                : -1;
            return Object.assign(d, {
              checked: idx !== -1,
              period:
                idx !== -1
                  ? ev.listOfDrivers[idx].period
                  : { periodType: "always" },
              paymenteBy: "myself",
              billingBy: "owner",
            });
          })
      : [];
  }

  handleScroll(e) {
    this.safeSetState({
      isScrolled: e.target.scrollTop > 0 ? true : false,
    });
  }

  handleOnCheck(e, list, obj) {
    const checkbox = e.target;
    const idx = this.state[list].findIndex((i) => i._id === obj._id);
    if (idx !== -1)
      this.safeSetState((prevState) => ({
        [list]: [
          ...prevState[list].slice(0, idx),
          Object.assign({}, obj, { checked: checkbox.checked }),
          ...prevState[list].slice(idx + 1),
        ],
      }));
  }

  handleOnCardSubmit(type, idx, from, to) {
    const period = {
      periodType: from !== "" && to !== "" ? "custom" : "always",
      period:
        from !== "" && to !== "" ? { startDate: from, stopDate: to } : null,
    };
    this.safeSetState((prevState) => ({
      [type]: [
        ...prevState[type].slice(0, idx),
        Object.assign({}, this.state[type][idx], { period }),
        ...prevState[type].slice(idx + 1),
      ],
    }));
  }

  handleOnClick(e, checkedGroups, checkedDrivers) {
    if (this.state.tabIndex === 0) {
      if (checkedGroups.length > 0 || checkedDrivers.length > 0)
        this.safeSetState({ tabIndex: 1 });
    } else if (this.state.tabIndex === 1) {
      if (checkedGroups.length > 0 || checkedDrivers.length > 0)
        this.safeSetState({ tabIndex: 2 });
    } else if (this.state.tabIndex === 2) {
      this.props.onAssign(checkedGroups, checkedDrivers);
    }
  }

  handleOnPaymentChange(type, id, payIndex) {
    if (type === "person") {
      const idx = this.state.drivers.findIndex((d) => d._id === id);
      if (idx !== -1)
        this.safeSetState((prevState) => ({
          drivers: [
            ...prevState.drivers.slice(0, idx),
            Object.assign({}, this.state.drivers[idx], {
              paymenteBy: payIndex === 0 ? "driver" : "myself",
              billingBy: "owner",
            }),
            ...prevState.drivers.slice(idx + 1),
          ],
        }));
    } else {
      const idx = this.state.groups.findIndex((g) => g._id === id);
      if (idx !== -1)
        this.safeSetState((prevState) => ({
          groups: [
            ...prevState.groups.slice(0, idx),
            Object.assign({}, this.state.groups[idx], {
              paymenteBy: payIndex === 0 ? "driver" : "myself",
              billingBy: payIndex === 0 ? "driver" : "owner",
            }),
            ...prevState.groups.slice(idx + 1),
          ],
        }));
    }
  }

  handleOnBillingChange(type, id, billingIndex) {
    if (type === "person") {
      const idx = this.state.drivers.findIndex((d) => d._id === id);
      if (idx !== -1)
        this.safeSetState((prevState) => ({
          drivers: [
            ...prevState.drivers.slice(0, idx),
            Object.assign({}, this.state.drivers[idx], {
              billingBy: billingIndex === 0 ? "driver" : "owner",
            }),
            ...prevState.drivers.slice(idx + 1),
          ],
        }));
    } else {
      const idx = this.state.groups.findIndex((g) => g._id === id);
      if (idx !== -1)
        this.safeSetState((prevState) => ({
          groups: [
            ...prevState.groups.slice(0, idx),
            Object.assign({}, this.state.groups[idx], {
              billingBy: billingIndex === 0 ? "driver" : "owner",
            }),
            ...prevState.groups.slice(idx + 1),
          ],
        }));
    }
  }

  resetState() {
    this.safeSetState({
      search: "",
      tabIndex: 0,
      isScrolled: false,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const checkedDrivers = this.state.drivers.filter((d) => d.checked);
    const checkedGroups = this.state.groups.filter((g) => g.checked);

    return (
      <Modal
        id="assignDriver"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState}
        centered
      >
        <Modal.Header>
          <div style={{ flex: 1 }} className="tabs">
            <p className={this.state.tabIndex === 0 ? "selected" : ""}>
              <Translate value="evs_driversAssignment" />
            </p>
            <p className={this.state.tabIndex === 1 ? "selected" : ""}>
              <Translate value="evs_payment" />
            </p>
            <p className={this.state.tabIndex === 2 ? "selected" : ""}>
              <Translate value="evs_billing" />
            </p>
          </div>
        </Modal.Header>
        <Modal.Body onScroll={this.handleScroll}>
          {this.state.tabIndex === 0 && (
            <>
              <div
                className={
                  "search-container " +
                  (this.state.isScrolled ? "shadowed" : "")
                }
              >
                <input
                  type="text"
                  className="search"
                  onChange={(e) => searchModule.setSearch(this, e.target.value)}
                />
              </div>
              <div className="driver-list">
                {this.state.groups
                  .filter((i) => searchModule.filter(this, i))
                  .map((g, idx) => (
                    <CheckCard
                      key={g._id}
                      type="period"
                      name={g.name || ""}
                      avatar={g.imageContent}
                      checked={g.checked}
                      period={g.period}
                      onChange={(e) => this.handleOnCheck(e, "groups", g)}
                      onSubmit={(e, from, to) =>
                        this.handleOnCardSubmit("groups", idx, from, to)
                      }
                    />
                  ))}
                <div className="separator">
                  <div className="line" />
                  <p>
                    <Translate value="evs_orInsert" />
                  </p>
                  <div className="line" />
                </div>
                {this.state.drivers
                  .filter((i) => searchModule.filter(this, i))
                  .map((d, idx) => (
                    <CheckCard
                      key={d._id}
                      type="period"
                      name={d.name || ""}
                      info={`${d.internationalPrefix} ${d.mobile}`}
                      avatar={d.imageContent}
                      checked={d.checked}
                      period={d.period}
                      onChange={(e) => this.handleOnCheck(e, "drivers", d)}
                      onSubmit={(e, from, to) =>
                        this.handleOnCardSubmit("drivers", idx, from, to)
                      }
                    />
                  ))}
              </div>
              {this.props.numberOfDrivers === 1 &&
                (this.props.numberOfDrivers < checkedDrivers.length ||
                  checkedGroups.length > 0) && (
                  <div className="modal-more-drivers">
                    <div className="overflow"></div>
                    <Modal.Dialog>
                      <Modal.Body>
                        <p>{I18n.t("assignDriver_editNumberOfDrivers")}</p>
                      </Modal.Body>

                      <Modal.Footer>
                        <button
                          type="button"
                          disabled={false}
                          onClick={this.props.onHide}
                        >
                          <Translate value="checkCard_close" />
                        </button>
                        <button
                          type="button"
                          disabled={false}
                          onClick={(e) =>
                            this.handleOnClick(e, checkedGroups, checkedDrivers)
                          }
                        >
                          <Translate value="otherChargers_continueBtn" />
                        </button>
                      </Modal.Footer>
                    </Modal.Dialog>
                  </div>
                )}
            </>
          )}
          {(this.state.tabIndex === 1 || this.state.tabIndex === 2) && (
            <div className="driver-list">
              {checkedGroups.length > 0 && (
                <div className="titled-card-container">
                  <p id="driver">
                    <Translate value="evs_driver" />
                  </p>
                  <p id="me">
                    <Translate value="evs_me" />
                  </p>
                  <div className="cards">
                    {checkedGroups.map((g) => (
                      <DoubleRadioCard
                        key={g._id}
                        id={g._id}
                        type="group"
                        name={g.name}
                        selectedEV={this.props.selectedEV}
                        avatar={g.imageContent}
                        tabIndex={this.state.tabIndex}
                        invoiceType={this.props.invoiceType}
                        invoiceCommunication={this.props.invoiceCommunication}
                        checkedGroups={checkedGroups}
                        onChangeInvoiceType={(e) =>
                          this.props.onChangeInvoiceType(e)
                        }
                        onChangeInvoiceCommunication={(e) =>
                          this.props.onChangeInvoiceCommunication(e)
                        }
                        checkedIndex={
                          this.state.tabIndex === 1
                            ? checkedGroups.length > 0
                              ? 1
                              : g.paymenteBy === "driver"
                              ? 0
                              : 1
                            : checkedGroups.length > 0
                            ? 1
                            : g.billingBy === "driver"
                            ? 0
                            : 1
                        }
                        onChange={
                          this.state.tabIndex === 1
                            ? this.handleOnPaymentChange
                            : this.handleOnBillingChange
                        }
                      />
                    ))}
                  </div>
                </div>
              )}
              {checkedDrivers.length > 0 && (
                <div className="titled-card-container">
                  <p id="driver">
                    <Translate value="evs_driver" />
                  </p>
                  <p id="me">
                    <Translate value="evs_me" />
                  </p>
                  <div className="cards">
                    {checkedDrivers.map((d) => {
                      return (
                        <DoubleRadioCard
                          key={d._id}
                          id={d._id}
                          type="person"
                          name={d.name}
                          selectedEV={this.props.selectedEV}
                          info={`${d.internationalPrefix} ${d.mobile}`}
                          avatar={d.imageContent}
                          tabIndex={this.state.tabIndex}
                          invoiceType={this.props.invoiceType}
                          invoiceCommunication={this.props.invoiceCommunication}
                          checkedDrivers={checkedDrivers}
                          checkedGroups={checkedGroups}
                          onChangeInvoiceType={(e) =>
                            this.props.onChangeInvoiceType(e)
                          }
                          onChangeInvoiceCommunication={(e) =>
                            this.props.onChangeInvoiceCommunication(e)
                          }
                          checkedIndex={
                            this.state.tabIndex === 1
                              ? checkedGroups.length > 0
                                ? 1
                                : d.paymenteBy === "driver"
                                ? 0
                                : 1
                              : checkedGroups.length > 0
                              ? 1
                              : d.billingBy === "driver"
                              ? 0
                              : 1
                          }
                          onChange={
                            this.state.tabIndex === 1
                              ? this.handleOnPaymentChange
                              : this.handleOnBillingChange
                          }
                        />
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            disabled={false}
            onClick={(e) =>
              this.handleOnClick(e, checkedGroups, checkedDrivers)
            }
          >
            {this.state.tabIndex < 2 ? (
              <Translate value="componentButton_next" />
            ) : (
              <Translate value="evs_save" />
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connect(null, { setAlert })(AssignDriver);
